import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-home-six',
  templateUrl: './home-six.component.html',
  styleUrl: './home-six.component.css'
})
export class HomeSixComponent {
  //Owl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['', ''],
  }

  slideStore = [
    {
      introtext: "ASM Global Trading FZE",
      title: "FMCG Wholesale",
      subtitle: "Distribution Across the UAE",
    },

    {
      introtext: "Reliable Supply Chain",
      title: "HORECA & Retail",
      subtitle: "Foodstuff, Grocery and Essentials",
    },

    {
      introtext: "Market Access Partner",
      title: "B2B Trading",
      subtitle: "Manufacturers, Retailers and Van Sellers",
    }

  ]

  // Features
  features =[
    {
      featureBox: "feature-box text-center xs-mb-50 feature-box-gradient-seven center-feature white-color border-radius-25",
      icon: "icon-laptop font-40px",
      title: "ERP Inventory Control",
      desc:"Data-driven stock planning, automated ordering support, and real-time inventory visibility.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient-eight center-feature white-color border-radius-25",
      icon: "icon-globe font-40px",
      title: "UAE-Wide Distribution",
      desc:"Service coverage across all seven emirates for retailers, HORECA customers, and B2B buyers.",
    },
    {
      featureBox: "feature-box text-center xs-mb-50 feature-box-gradient-seven center-feature white-color border-radius-25",
      icon: "icon-dial font-40px",
      title: "Fast Local Delivery",
      desc:"In-house delivery vans plus trusted logistics partners for reliable door-to-door supply.",
    }
  ]

  // Team
  
  slideStoreTwo : { title: string; subtitle: string; image: string; index: number }[] = [
    {
      title: "Founder, Owner & CEO",
      subtitle: "Mr. Abdus Sabur Miah",
      image: "team-1.jpg",
      index: 0
    },
    {
      title: "ASM Global Trading FZE",
      subtitle: "B2B Distribution Team",
      image: "team-2.jpg",
      index: 1
    }
  ];

  socialLinks = [
    { iconOuter: "facebook", iconInner: ['icofont icofont-social-facebook'] },
    { iconOuter: "twitter", iconInner: ['icofont icofont-social-twitter'] },
    { iconOuter: "pinterest", iconInner: ['icofont icofont-social-pinterest'] },
  ];

  // Services
  services = [
    {
      icon: "icon-tools font-30px white-color",
      title: "HORECA Supply",
      desc: "Spices, edible oil, rice, pulses, sugar, tea, beverages, and packing materials for foodservice buyers.",
    },
    {
      icon: "icon-linegraph font-30px white-color",
      title: "Grocery Distribution",
      desc: "Fast-moving supermarket items including snacks, biscuits, juices, energy drinks, puffed rice, and daily essentials.",
    },
    {
      icon: "icon-globe font-30px white-color",
      title: "Commercial Brokerage",
      desc: "Trade support for petrochemicals, lubricants, bitumen, stone, coal, and selected food categories.",
    },
    {
      icon: "icon-tools font-30px white-color",
      title: "Break-Bulk Wholesale",
      desc: "Large manufacturer lots broken into practical order sizes for local retailers and van sellers.",
    },
    {
      icon: "icon-beaker font-30px white-color",
      title: "Private Label Support",
      desc: "Brand, white-label, repackaging, bundling, and local market preparation support where required.",
    },
    {
      icon: "icon-layers font-30px white-color",
      title: "Market Access",
      desc: "Supplier entry support, shelf placement, local sales activation, and buyer network development.",
    },
  ]

  //Features

  leftServices = [
    {
      title: "3,000 Sq. Ft. Warehouse",
      desc: "Temperature-controlled storage with more than 200 pallet positions for dependable product handling.",
    },
    {
      title: "Retail-Level Insight",
      desc: "Direct experience from supermarkets, hypermarkets, and food businesses helps us understand real consumer demand.",
    },
    {
      title: "Flexible B2B Supply",
      desc: "Competitive wholesale pricing, low MOQs, and credit terms subject to approval.",
    }
  ]

  rightServices = [
    {
      title: "4 Commercial Vehicles",
      desc: "Owned fleet supported by van-selling partners and on-call logistics providers.",
    },
    {
      title: "GPS-Enabled Delivery",
      desc: "Real-time tracking and route coordination for more predictable distribution operations.",
    },{
      title: "Cash & Carry Operations",
      desc: "Convenient supply model for van sellers, retailers, and HORECA customers.",
    }
  ]

  // Brands
  portfolios = [
    {
      img: "ajmain.jpeg",
      title: "Ajmain",
      subTitle: "We Care"
    },
    {
      img: "gold_mark.jpeg",
      title: "GoldMark",
      subTitle: "Consumer Brand"
    },
    {
      img: "rani.jpeg",
      title: "Rani",
      subTitle: "Consumer Brand"
    },
    {
      img: "square.jpeg",
      title: "Square",
      subTitle: "Consumer Brand"
    }
  ]

  // Pricing
  pricing = [
    {
      title: "Retailer Supply Program",
      subTitle: "For supermarkets, groceries, van sellers, and HORECA customers.",
      currency: "",
      amount: "B2B",
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Competitive wholesale pricing',
        'Low minimum order quantities',
        'Door-to-door delivery support',
        'Cash & carry availability',
        'Flexible credit terms subject to approval',
        'Consistent stock planning'
      ]
    },

    {
      title: "Manufacturer Partner Program",
      subTitle: "For suppliers seeking UAE market entry and stronger shelf visibility.",
      currency: "",
      amount: "UAE",
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Market entry support',
        'Local sales and distribution network',
        'Retail and B2B buyer access',
        'Private label and repackaging support',
        'Storage facility on demand',
        'Market information and counselling'
      ]
    }
  ];

  // Owl Testimonial
  customOptionsThree: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:3,
      }
    }
  }

  slideStoreThree = [
    {
      title: "Retail Partner",
      subTitle: "UAE Grocery Buyer",
      description: "ASM Global Trading FZE supports our daily purchasing with dependable stock, responsive delivery, and practical wholesale order sizes.",
      image: "assets/images/team/avatar-1.jpg",
    },

    {
      title: "HORECA Customer",
      subTitle: "Foodservice Operator",
      description: "Their product range covers the essentials we need for kitchen operations, with clear communication and reliable delivery planning.",
      image: "assets/images/team/avatar-2.jpg",
    },

    {
      title: "Supplier Partner",
      subTitle: "FMCG Brand",
      description: "ASM helps brands reach retailers faster through local market knowledge, sales relationships, and distribution capacity.",
      image: "assets/images/team/avatar-3.jpg",
    },

    {
      title: "Van Seller",
      subTitle: "Cash & Carry Buyer",
      description: "The cash and carry model makes repeat purchasing easier, especially for fast-moving grocery and foodstuff products.",
      image: "assets/images/team/avatar-4.jpg",
    }

  ]

  //Brand Logos
  logos = [
    {
      img: "1-colored.png"
    },
    {
      img: "2-colored.png"
    },
    {
      img: "3-colored.png"
    },
    {
      img: "4-colored.png"
    },
    {
      img: "5-colored.png"
    },
    {
      img: "6-colored.png"
    }
  ]

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  public sendEmail(event: Event): void {
    event.preventDefault();

    const subject = encodeURIComponent(`Website inquiry from ${this.formData.user_name}`);
    const body = encodeURIComponent(
      `Name: ${this.formData.user_name}\nEmail: ${this.formData.user_email}\n\n${this.formData.message}`
    );

    window.location.href = `mailto:miahsabur@gmail.com?subject=${subject}&body=${body}`;
    this.resetForm();
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }

  socialMedia = [
    {
      iconClass: "icon facebook",
      icon:"icofont icofont-social-facebook"
    },
    {
      iconClass: "icon twitter",
      icon:"icofont icofont-social-twitter"
    },
    {
      iconClass: "icon behance",
      icon:"icofont icofont-social-behance"
    },
    {
      iconClass: "icon linkedin",
      icon:"icofont icofont-social-linkedin"
    },
    {
      iconClass: "icon youtube",
      icon:"icofont icofont-social-youtube"
    },
    {
      iconClass: "icon instagram",
      icon:"icofont icofont-social-instagram"
    }
  ]
}
